const MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
const MAX_CACHED_REPAIRS = 8;

const repairs = new Map<string, Promise<Blob | null>>();

export const isUnsupportedAudio = (
  code: number | null | undefined,
): boolean => code === MEDIA_ERR_SRC_NOT_SUPPORTED;

const rememberRepair = (url: string, run: Promise<Blob | null>) => {
  repairs.delete(url);
  repairs.set(url, run);
  while (repairs.size > MAX_CACHED_REPAIRS) {
    const oldest = repairs.keys().next().value;
    if (oldest === undefined || oldest === url) return;
    repairs.delete(oldest);
  }
};

export const loadPlayableAudio = (
  url: string,
  transcode: (input: Blob) => Promise<Blob>,
  fetchImpl: typeof fetch = fetch,
): Promise<Blob | null> => {
  const existing = repairs.get(url);
  if (existing) return existing;

  const current: { promise: Promise<Blob | null> | null } = { promise: null };
  const run = (async (): Promise<Blob | null> => {
    let blob: Blob | null = null;
    try {
      const response = await fetchImpl(url);
      if (response.ok) {
        const bytes = await response.blob();
        const input = new File([bytes], "voice.m4a", { type: "audio/mp4" });
        blob = await transcode(input);
      }
    } catch {
      blob = null;
    }
    if (!blob && repairs.get(url) === current.promise) repairs.delete(url);
    return blob;
  })();

  current.promise = run;
  rememberRepair(url, run);
  return run;
};
